// extracted by mini-css-extract-plugin
export var Letter = "Logomark-module--Letter--6f95a";
export var Outer = "Logomark-module--Outer--043aa";